import React, { Component } from 'react';
import { Hyperlink } from './Hyperlink';
import { withUser } from '../user/UserContext';
import { isUrlInternal } from '../utils/url-utils/urlUtils';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from './modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../user/user.types';

type Props = {
  className: string;
  url: string;
  source: string;
  children: React.ReactNode;
} & WithRestrictedModalProps &
  UserContextType;

export class RawHyperlinkRestrictedBaseModal extends Component<Props> {
  static defaultProps = {
    className: '',
  };

  render() {
    const {
      className,
      url,
      source,
      children,
      accessPremium,
      openRestrictedModal,
      currentUser,
    } = this.props;
    return (
      <Hyperlink
        className={className}
        // We have the whitelist so we can show all links to snapshots
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...(accessPremium || currentUser.isSnapshotsCrawler
          ? {
              href: url,
              source: isUrlInternal(url) ? source : '',
            }
          : {
              onClick: () => openRestrictedModal(source),
            })}
      >
        {children}
      </Hyperlink>
    );
  }
}

export const HyperlinkRestrictedBaseModal = withRestrictedModal(
  withUser(RawHyperlinkRestrictedBaseModal),
);
